import { vec3 } from 'gl-matrix';
import { DrawableObject, RenderConfiguration, RenderMode, RenderSettings } from '../renderer';
import { PropertyAnimation } from '../animation';
import { ObjectInteraction } from '../object';
import { TextManager } from './TextManager';
import { Context } from '../context/Context';
import { Camera } from '../camera';

export abstract class TextElement implements DrawableObject {
  public renderConfiguration: RenderConfiguration = {
    static: false,
    culling: 'none',
    order: 9999,
    modes: [RenderMode.Overlay],
    shadow: 'none',
  };

  animatedProperties?: PropertyAnimation;
  interaction?: ObjectInteraction;

  protected _text: string = '';
  protected _position?: vec3 | number[];

  public offset: vec3 | number[];

  private positionLink?: PositionLink;

  constructor(
    public textManager: TextManager,
    public inWorldSpace: boolean = true,
    public centerText: boolean = true,
  ) {
    this.positionLink = undefined;
    this._position = vec3.fromValues(0, 0, 0);
    this.offset = vec3.fromValues(0, 0, 0);
  }

  public set position(pos: vec3 | number[]) {
    this._position = pos;
    this.positionLink = undefined;
  }

  public get position(): vec3 | number[] {
    if (this._position) {
      return this._position;
    } else {
      let pos = this.positionLink!.position;

      return vec3.fromValues(pos[0], pos[1], pos[2]);
    }
  }

  public linkPosition(obj: PositionLink) {
    this.positionLink = obj;
    this._position = undefined;
  }

  public get text() {
    return this._text;
  }

  public set text(str: string) {
    this._text = str;
  }

  public abstract render(ctx: Context, camera: Camera, settings: RenderSettings): void;

  public abstract destroy(): void;
}

type PositionLink = {
  position: vec3 | number[];
};
